import { useQuery } from "@tanstack/react-query";
import { getActiveBundles } from "../services/get-active-bundles";

export function useActiveBundles(options?: {
  staleTime?: number;
  // Scope the list server-side to one region (Region.id). Omit for all regions.
  regionId?: string;
  // Gate the fetch (e.g. cascades that wait for a region to be picked).
  enabled?: boolean;
}) {
  return useQuery({
    // regionId is part of the key: each region's list is its own cache entry,
    // so switching regions in a cascade never shows another region's bundles.
    queryKey: ["active-bundles", options?.regionId ?? "all"],
    queryFn: () => getActiveBundles(options?.regionId),
    refetchOnWindowFocus: false,
    enabled: options?.enabled ?? true,
    // Default: 30-min economy for read-mostly consumers (user pages, wizards).
    // Pickers that must reflect just-created/retired bundles (e.g. the coupon
    // form) pass staleTime: 0 — the shared cache still renders instantly, but
    // every mount revalidates in the background.
    staleTime: options?.staleTime ?? 1000 * 60 * 30,
  });
}
